import { render } from "./investPage.vue?vue&type=template&id=c51632ec"
import script from "./investPage.vue?vue&type=script&lang=js"
export * from "./investPage.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__